import React from 'react';
import {InputItem} from 'antd-mobile';
import PropTypes from 'prop-types';

const NumberInput = props => (
    <InputItem 
        type='digit'
        value={props.value}
        defaultValue={props.defaultValue}
        clear
        style={{textAlign: 'right', fontSize: '14px', color: '#004586', fontFamily: 'fff-equipe', fontWeight: '700'}}
        min={props.min}
        max={props.max}
        placeholder={props.placeholder}
        labelNumber={10}
        onChange={v => props.onChange(parseInt(v))}
        id={props.id}
        onKeyDown={e => {
            if(e.keyCode === 13) {
                const element = document.getElementById(props.id);
                element.blur();
            }
        }}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
    >
        <span className='common' style={{marginLeft: '10px', fontSize: '14px'}}>{props.label}</span>
    </InputItem>
)

NumberInput.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    defaultValue: PropTypes.number,
    placeholder: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    value: PropTypes.number
}

export default NumberInput;